import { epProjectEditedDocuments } from '../../functions/src/common/epProjectV2';

export type EpProjectLink = { type: string; source: string; id: string; title: string; reference: string; status: string };
export type EpProjectSource = Omit<EpProjectLink, 'type'> & { serviceCode: string; projectReference?: string };

const completed = (status: string) => ['delivered', 'invoiced', 'completed'].includes(status);
const surveyLink = (link: EpProjectLink) => link.type === 'EP-11' && link.source === 'service_request' && completed(link.status);

export function epProjectSurveyChoices(links: EpProjectLink[], sources: EpProjectSource[]) {
    const surveys = new Map<string, EpProjectLink>();
    for (const link of links)
        if (surveyLink(link))
            surveys.set(link.id, link);
    for (const source of sources) {
        if (source.source !== 'service_request')
            continue;
        if (completed(source.status) &&
            (['EP-11', 'S-11'].includes(source.serviceCode) || /advance.*site survey/i.test(source.title)))
            surveys.set(source.id, { type: 'EP-11', source: source.source, id: source.id,
                title: source.title, reference: source.reference, status: source.status });
        else
            surveys.delete(source.id);
    }
    return [...surveys.values()];
}

type SurveyProject = {
    links: EpProjectLink[];
    venues: Array<{ ep11RequestId: string; status: string }>;
    documents: Record<string, string>;
    aiDocuments?: Record<string, string>;
    qa: { checked: number[]; signature: string };
};

export function assignEpProjectSurvey<T extends SurveyProject>(project: T, index: number, survey?: EpProjectLink): T {
    if (!project.venues[index] || survey && !surveyLink(survey))
        return project;
    const linked = survey && project.links.some(link => link.type === 'EP-11' && link.source === survey.source && link.id === survey.id);
    return { ...project,
        links: !survey ? project.links : linked
            ? project.links.map(link => link.type === 'EP-11' && link.source === survey.source && link.id === survey.id ? survey : link)
            : [...project.links, survey],
        venues: project.venues.map((venue, at) => at === index
            ? { ...venue, ep11RequestId: survey?.id || '', status: survey?.status || 'not_started' } : venue),
        documents: epProjectEditedDocuments(project.documents, project.aiDocuments), qa: { checked: [], signature: '' } };
}
